import { useState } from 'react'
import * as React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import {
  GqlScreenScrapNewsListDocument,
  NewsCardItem_NewsItemFragment,
  NotificationScope,
  PageLayoutDocument,
  GqlUserScrapCountsDocument,
  useGqlScreenScrapNewsListQuery,
  useRemoveAllScrapMutation,
} from 'generated/graphql'
import Button from '@app.components/Button'
import DeleteNewsItemScrapModal from '@app.feature/accounts/scrap/component/DeleteNewsItemScrapModal'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import { getWebviewHref } from '@app.modules/util'
import useFlutterInappwebview from 'hooks/useFlutterInappwebview'
import NewsCardList from '../../screen/menus/News/NewsCardList'

// TODO: 스크랩 페이지 다시 만들 예정. 지금은 기존 컴포넌트에 해당 탭만 표시해서 보여주고 있습니다.

type TProps = {
  className?: string
}

const ScreenScrapNewsListMobile: React.FC<TProps> = ({ className }) => {
  const router = useRouter()
  const isWebview = useIsWebview()
  const { fluterInappwebview } = useFlutterInappwebview()

  const currentPage = router.query.page ? +router.query.page : 1
  const variables = {
    pagination: {
      page: currentPage,
      pageSize: 10,
    },
  }
  const [open, setOpen] = useState(false)
  const { data } = useGqlScreenScrapNewsListQuery({
    variables,
    fetchPolicy: 'cache-and-network',
  })

  const [mutate] = useRemoveAllScrapMutation()
  const handleConfirm = () => {
    mutate({
      refetchQueries: [
        {
          query: PageLayoutDocument,
          variables: {
            notificationType: NotificationScope.NOTIFICATION,
          },
        },
        {
          query: GqlUserScrapCountsDocument,
        },
        {
          query: GqlScreenScrapNewsListDocument,
          variables,
        },
      ],
    })
    if (isWebview) {
      fluterInappwebview?.callHandler('reportRemoveAllScraps')
    }

    setOpen(false)
  }

  return (
    <StyledWrapper className={className}>
      <div className="button-list">
        <Link
          href={{
            pathname: getWebviewHref('/calendar', isWebview),
            query: { activityType: 'activity', tab: 'myActivity' },
          }}
        >
          <Button className="calandar-btn" color="black" variant="outlined">
            내 스크랩 달력
          </Button>
        </Link>

        <Button
          className="delete-btn"
          color="lightGrey"
          disabled={data?.viewerBookmarks?.totalCount === 0}
          onClick={() => setOpen(true)}
        >
          모두삭제
        </Button>
      </div>
      <NewsCardList
        totalCount={data?.viewerBookmarks?.totalCount || 0}
        data={
          data?.viewerBookmarks?.nodes.filter(
            (node) => node?.viewerHasBookmarked === true,
          ) as NewsCardItem_NewsItemFragment[]
        }
      />
      <DeleteNewsItemScrapModal
        totalCount={data?.viewerBookmarks?.totalCount}
        open={open}
        onConfirm={handleConfirm}
        onClose={() => setOpen(false)}
      />
    </StyledWrapper>
  )
}

export default ScreenScrapNewsListMobile

const StyledWrapper = styled.div`
  .button-list {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0;
    height: 0px;
    padding: 0 20px;
    gap: 0px;
    .calandar-btn,
    .delete-btn {
      width: inherit;
      height: 36px;
      transform: translate(0, -72px);
    }
    .calandar-btn {
      padding: 8px 13px;
      margin-right: 16px;
      font-size: 12px;
      letter-spacing: -0.2px;
    }
    .delete-btn {
      width: 81.77px;
      height: 40px;
      font-size: 12px;
      letter-spacing: -0.2px;
      padding: 0 5px;
      font-weight: 400;
    }
  }
`
